export default {
  1: { width: 15, length: 10, height: 10 },
  2: { width: 20, length: 15, height: 10 },
  3: { width: 20, length: 20, height: 15 },
  4: { width: 30, length: 20, height: 20 },
  5: { width: 35, length: 25, height: 20 },
  6: { width: 45, length: 25, height: 20 },
  7: { width: 40, length: 30, height: 25 },
  8: { width: 45, length: 40, height: 30 },
  9: { width: 55, length: 45, height: 35 },
};
